import {useEffect, useState} from "react";
import {othersTotal} from "../../../utils/pravno";
import {requester} from "../../../services/requester";
import baseUrl from "../../../baseUrl";
import {useParams} from "react-router-dom";

export const CompanyTotalData = ({bullstat}) => {
    const request = requester();
    const {year} = useParams();
    const [dataInitialState, setDataInitialState] = useState({});
    const [dataOthersState, setDataOthersState] = useState(null);
    const [dataRoadsState, setDataRoadsState] = useState(null);
    const [dataOthersStateAlternative, setDataOthersStateAlternative] = useState(null);
    const [dataDealsState, setDataDealsState] = useState({});
    const [dataDrawingState, setDataDrawingState] = useState({});
    const [dataCropsState, setDataCropsState] = useState([]);


    useEffect(() => {
        Promise.all([
            request.get(`${baseUrl()}/companies-initial-info/total/${year}/${bullstat}/sum`),
            request.get(`${baseUrl()}/others/total/${year}/${bullstat}/sum`),
            request.get(`${baseUrl()}/deals/total/${year}/${bullstat}/sum`),
            request.get(`${baseUrl()}/drawings/total/${year}/${bullstat}/sum`),
            request.get(`${baseUrl()}/drawings/crops/${year}/${bullstat}`)
        ])
            .then(([dataInitial, dataOthers, dataDeals, dataDrawing, dataCrops]) => {
                setDataInitialState(dataInitial);
                setDataDealsState(dataDeals);
                setDataDrawingState(dataDrawing);
                setDataCropsState(dataCrops);

                const sumWhiteSpots = dataOthers.sum_white_spots || 0;
                const sumRoads = dataOthers.sum_roads || 0;
                const sumOthersVal = dataOthers.sum_others || 0;
                const sumOthersPlus = dataOthers.sum_others_plus || 0;
                const sumCorrection = dataOthers.sum_correction || 0;

                setDataOthersState(sumWhiteSpots);
                setDataRoadsState(sumRoads);
                // Н0: приносът на другите площи — една дефиниция (utils/pravno.js).
                setDataOthersStateAlternative(
                    othersTotal(sumWhiteSpots, sumRoads, sumOthersVal, sumCorrection,
                                sumOthersPlus));
            })
    }, [])


    return (
        <>
            <table className="table">
                <thead>
                <tr>
                    <th className="text-center" scope="col">Декларирана</th>
                    <th className="text-center" scope="col">Годна</th>
                    <th className="text-center" scope="col">БП</th>
                    <th className="text-center" scope="col">Пътища</th>
                    <th className="text-center" scope="col">ДЗ</th>
                    <th className="text-center" scope="col">Правно</th>
                    <th className="text-center" scope="col">Изчертано</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className="text-center">{dataInitialState.sum_declared_land?.toFixed(2)}</td>
                    <td className="text-center">{dataInitialState.sum_suitable_land?.toFixed(2)}</td>
                    <td className="text-center">{dataOthersState?.toFixed(2)}</td>
                    <td className="text-center">{dataRoadsState?.toFixed(2)}</td>
                    <td className="text-center">{dataDealsState.sum_deals_total?.toFixed(2)}</td>
                    <td className="text-center">{((dataInitialState.sum_suitable_land || 0) + (dataDealsState.sum_deals_total || 0) + (dataOthersStateAlternative || 0)).toFixed(2)}</td>
                    <td className="text-center">{dataDrawingState.sum_drawings?.toFixed(2)}</td>
                </tr>
                </tbody>
            </table>
            <h4 style={{color: "var(--app-gold)"}}>Общо култури:</h4>
            <table className="table">
                <thead>
                <tr>
                    <th className="text-left" scope="col">Култура</th>
                    <th className="text-center" scope="col">Площ</th>
                    <th className="text-center" scope="col">Процент</th>
                </tr>
                </thead>
                <tbody>
                    {dataCropsState.map((item, index) => (
                        <tr key={index}>
                            <td className="text-left">{item.crop ? item.crop : "неопределено"}</td>
                            <td className="text-center">{item.total_area?.toFixed(2)}</td>
                            <td className="text-center">{((item.total_area/dataDrawingState.sum_drawings)*100)?.toFixed(2)}%</td>
                        </tr>
                    ))}

                </tbody>
            </table>
        </>
    )
};